module.exports = __webpack_public_path__ + "static/cape_of_the_mountebank-bbc180bac509591e276cd859321429cf.jpeg";